import AddVehicleInfoModal from './add-vehicle-info-modal.vue'
export default AddVehicleInfoModal
